export default __webpack_public_path__ + "static/Plots0054-4b57297e1acd016a08662ada5690309a.jpg";